export const toBase64 = (blob) => {
	return new Promise((resolve, reject) => {
		const reader = new window.FileReader()
		reader.readAsDataURL(blob)
		reader.onloadend = () => {
			const base64data = reader.result
			resolve(base64data)
		}
		reader.onerror = reject
	})
}

export const base64StringToFile = (base64String, fileName) => {
	if (!base64String) {
		return undefined
	}
	let arr = base64String.split(","),
		mime = arr[0].match(/:(.*?);/)[1],
		bstr = atob(arr[1]),
		n = bstr.length,
		u8arr = new Uint8Array(n)

	while (n--) {
		u8arr[n] = bstr.charCodeAt(n)
	}
	return new File([u8arr], fileName, { type: mime })
}
